import { useEffect } from "react"
import { isDevelopment, isPadeDomain } from "utils/utils"

export function useHubspotChat(portalId: string) {
  useEffect(() => {
    if (!isPadeDomain() || isDevelopment) return

    if (document.getElementById("hubspot-script")) return

    const script = document.createElement("script")
    script.id = "hubspot-script"
    script.src = `https://js.hs-scripts.com/${portalId}.js`
    script.async = true
    script.defer = true

    document.body.appendChild(script)
  }, [portalId])
}
